import { jsPDF } from "jspdf";
import "jspdf-autotable";

/**
 * Exporta linhas selecionadas para PDF (mesmo padrão do GenericTable).
 */
export function exportSelectedRowsPdf({
  rows = [],
  columns = [],
  selectedIds = [],
  title = "Resultados da Busca",
  fileName = "resultados_busca",
}) {
  const idSet = new Set(selectedIds.map((id) => String(id)));
  const selectedData = rows.filter((row) => idSet.has(String(row.id)));
  if (!selectedData.length) return;

  const doc = new jsPDF();
  doc.text(title, 20, 10);
  const headers = columns.map((col) => col.headerName || col.field);
  const data = selectedData.map((row) =>
    columns.map((col) => {
      if (typeof col.valueGetter === "function") {
        try {
          const v = col.valueGetter(row[col.field], row, col, null);
          return v ?? row[col.field] ?? "";
        } catch {
          return row[col.field] ?? "";
        }
      }
      return row[col.field] ?? "";
    })
  );
  doc.autoTable({ head: [headers], body: data });
  doc.save(`${fileName}.pdf`);
}

/**
 * Monta dados para CSVLink a partir das linhas selecionadas.
 */
export function buildSelectedRowsCsvData({ rows = [], columns = [], selectedIds = [] }) {
  const idSet = new Set(selectedIds.map((id) => String(id)));
  const selectedData = rows.filter((row) => idSet.has(String(row.id)));
  return selectedData.map((row) => {
    const csvRow = {};
    columns.forEach((col) => {
      const label = col.headerName || col.field;
      if (typeof col.valueGetter === "function") {
        try {
          csvRow[label] = col.valueGetter(row[col.field], row, col, null) ?? row[col.field] ?? "";
        } catch {
          csvRow[label] = row[col.field] ?? "";
        }
      } else {
        csvRow[label] = row[col.field] ?? "";
      }
    });
    return csvRow;
  });
}
